<template>
  <div class="payment-steps">
    <div class="steps-indicator">
      <div class="step" :class="{ active: currentStep === 1, completed: currentStep > 1 }">
        <div class="step-number">1</div>
        <div class="step-label">Fatura Adresi</div>
      </div>
      <div class="step-line" :class="{ active: currentStep > 1 }"></div>
      <div class="step" :class="{ active: currentStep === 2, completed: currentStep > 2 }">
        <div class="step-number">2</div>
        <div class="step-label">Kart Bilgileri</div>
      </div>
    </div>
    
    <a-alert v-if="errorMessage" type="error" :message="errorMessage" show-icon style="margin-bottom: 20px;" />
    
    <BillingAddressForm 
      v-if="currentStep === 1" 
      :initialValues="billingForm"
      @submit="onBillingFormSubmit" 
      @cancel="$emit('cancel')"
    />
    
    <CreditCardForm 
      v-if="currentStep === 2" 
      :initialValues="cardForm"
      @submit="onCardFormSubmit" 
    />
  </div>
</template>

<script>
import BillingAddressForm from './BillingAddressForm.vue';
import CreditCardForm from './CreditCardForm.vue';
import { mapState } from 'vuex';

export default {
  name: "PaymentSteps",
  components: {
    BillingAddressForm,
    CreditCardForm
  },
  computed: {
    ...mapState({
      billingDetail: state => state.site.billingDetail || {},
    }),
  },
  data() {
    return {
      currentStep: 1,
      billingForm: {},
      cardForm: {},
      errorMessage: ""
    };
  },
  created() {
    if (this.billingDetail && this.billingDetail.name) {
      this.currentStep = 2;
    }
  },
  methods: {
    goToNextStep() {
      if (this.currentStep < 2) {
        this.currentStep++;
        this.errorMessage = "";
      }
    },
    onBillingFormSubmit(formData) {
      this.billingForm = formData;
      const billingData = {
        ...formData,
        step: 'billing-address'
      };
      this.$emit('submit', billingData);
    },
    onCardFormSubmit(formData) {
      this.cardForm = formData;
      const cardData = {
        ...formData,
        step: 'credit-card'
      };
      this.$emit('submit', cardData);
    },
    nextStep() {
      this.goToNextStep();
    },
    showError(message) {
      this.errorMessage = message;
    }
  }
};
</script>

<style scoped>
.payment-steps {
  padding: 20px;
}

.steps-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.step-number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #f5f5f5;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-weight: 500;
  border: 2px solid #e0e0e0;
}

.step.active .step-number {
  background-color: #22272d;
  color: white;
  border-color: #22272d;
}

.step.completed .step-number {
  background-color: #52c41a;
  color: white;
  border-color: #52c41a;
}

.step-label {
  font-size: 14px;
  color: #999;
}

.step.active .step-label,
.step.completed .step-label {
  color: #333;
  font-weight: 500;
}

.step-line {
  flex: 1;
  height: 2px;
  background-color: #e0e0e0;
  margin: 0 20px;
  position: relative;
  top: -19px;
}

.step-line.active {
  background-color: #52c41a;
}
</style> 